import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Camera, CameraType } from "react-camera-pro";

export type WebcamCaptureHandle = {
  capture: () => string | null;
};

type Props = {
  onCapture: (imageSrc: string) => void;
};

export const WebcamCapture = forwardRef<WebcamCaptureHandle, Props>(
  ({ onCapture }, ref) => {
    const camera = useRef<CameraType>(null);

    useImperativeHandle(ref, () => ({
      capture: () => {
        const photo = camera.current?.takePhoto();
        if (typeof photo === "string") {
          onCapture(photo);
          return photo;
        }
        return null;
      },
    }));

    return (
      <Camera
        ref={camera}
        aspectRatio="cover"
        facingMode="environment"
        errorMessages={{
          noCameraAccessible:
            "No camera device accessible. Please connect your camera or try a different browser.",
          permissionDenied:
            "Permission denied. Please refresh and give camera permission.",
          switchCamera:
            "It is not possible to switch camera because only one camera is available.",
          canvas: "Canvas is not supported.",
        }}
      />
    );
  }
);

WebcamCapture.displayName = "WebcamCapture";